var firebaseConfig = {
    apiKey: "AIzaSyCRbUYQRCaLdcQdfNMT-yCRwF5qggZnA3o",
    authDomain: "sneak-peak.getitout.io", 
    databaseURL: "https://getitout-prod.firebaseio.com",
    projectId: "getitout-prod",
    storageBucket: "getitout-prod.appspot.com", //TODO extra storage Bucket
    messagingSenderId: "625646772792",
    appId: "1:625646772792:web:5a8e7096fab73fcf557ccd",
    measurementId: "G-Z9R2K1HTPZ"
  };

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export const db = firebase.firestore();
  export const functions = firebase.functions();
  export const storage = firebase.storage();
  export const analytics = firebase.analytics();
  export const performance = firebase.performance();

